import { BoundedContent, Box } from '@vp/swan';
import TabbedButtonLinkGarden from '../../../../components/TabbedButtonLinkGarden/TabbedButtonLinkGarden';
import { useTrack } from '../../../../utils/analytics';
import { IndustryBusinessNameIdeasData } from '../content/explore-business-ideas-data';

interface ExploreIdeasProps {
    industryBusinessNameIdeasData: IndustryBusinessNameIdeasData;
}

const ExploreIdeas = ({ industryBusinessNameIdeasData }: ExploreIdeasProps) => {
    const track = useTrack();

    const onBusinessNameIdeasClickHandler = (
        currentPagePath: string,
        destinationPagePath: string,
        businessNameIdea: string,
    ) => {
        track('Navigation Clicked', {
            pageSection: 'Explore Business Name Ideas',
            category: 'Business Name Generator',
            label: 'Content:ExploreBusinessNameIdeas',
            eventDetail: `${currentPagePath};${destinationPagePath};ExploreBusinessNameIdeas;businessNameIdeasButton`,
            navigationDetail: 'businessNameIdeasButton',
            businessNameIdea,
        });
    };

    return (
        <Box
            paddingY={{ xs: '8', md: '9' }}
            marginBottom="between-sections"
            backgroundColor="warm-white"
        >
            <BoundedContent>
                <TabbedButtonLinkGarden
                    title="Not sure where to start? Explore ideas"
                    tabHeaderAriaLabel="Industry based business name ideas"
                    targetBasePath="/digital-marketing/business-name-generator"
                    onBusinessNameIdeasClickHandler={onBusinessNameIdeasClickHandler}
                    tabbedButtonLinkGardenData={industryBusinessNameIdeasData}
                />
            </BoundedContent>
        </Box>
    );
};

export default ExploreIdeas;
